import { type ReactElement } from 'react'
import { Card, CardBody } from '@stuller/stullercom/ui'
import { SerializedStoneSpecialRequestModal } from '../shared/SerializedStoneSpecialRequestModal'

interface SerializedStoneSpecialRequestProps {
  /**
   * The serialized stone type
   */
  isDiamond: boolean
}

function SerializedStoneSpecialRequest ({ isDiamond }: SerializedStoneSpecialRequestProps): ReactElement {
  return (
    <div className='container mw-xxl p-4'>
      <Card className='mb-5'>
        <CardBody className='p-4'>
          <h2>Need a Special {isDiamond ? 'Diamond' : 'Gemstone'}?</h2>
          <p>Call or Live chat with one of our sourcing specialists to get started. Lead times vary, but most quotes are provided within 24 hrs.</p>
          <SerializedStoneSpecialRequestModal />
        </CardBody>
      </Card>
    </div>
  )
}

export {
  SerializedStoneSpecialRequest
}
